<template>
  <div class="container">
    <div class="bg">
      <div class="control">
        <h4 class="f16">{{ localStorage.translations.pages.common.buttons['sohranit'] }} PDF</h4>
        <button class="control_btn f14" @click="generatePdf">
          {{
            progress > 0 && progress !== 100
              ? progress + '%'
              : localStorage.translations.pages.common.buttons['sohranit']
          }}
        </button>
      </div>
      <div class="borderBox">
        <section class="page" id="target">
          <HeaderPdf id="pdf_header" />
          <PersonalAreaPdfBody @onImgReady="onImgReady" :userId="$attrs.userId" ref="target" />
          <FooterPdf id="pdf_footer" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import VueHtml2pdf from 'vue-html2pdf'
// import rasterizeHTML from 'rasterizeHTML'
import html2pdf from 'html2pdf.js'
// import html2canvas from 'html2canvas'

import HeaderPdf from 'components/pdf/HeaderPdf'
import FooterPdf from 'components/pdf/FooterPdf'
import PersonalAreaPdfBody from 'components/personalArea/pdf/PersonalAreaPdfBody'

export default {
  name: 'PersonalAreaPdf',
  components: {
    HeaderPdf,
    PersonalAreaPdfBody,
    FooterPdf,
    // VueHtml2pdf
  },
  data: () => ({
    progress: 0,
    last_name: null,
    first_name: null,
    imgReady: false,
    imgCheck: false,
  }),
  created() {
    this.scrollToTop()
    this.getUser()
  },
  watch: {
    userData() {
      this.last_name = this.userData.last_name
      this.first_name = this.userData.first_name
    },
  },
  // mounted() {
  //    this.fileNamePdf = this.personalAreaUserPdf ? this.userData.last_name + '_' + this.userData.first_name : this.commonUserData.last_name + '_' + this.commonUserData.first_name
  // },
  computed: {
    ...mapGetters('user', ['userData']),
    ...mapGetters('commonUser', ['commonUserData']),
    personalAreaUserPdf() {
      return this.$route.name === 'PersonalAreaPdf'
    },
    // fileNamePdf() {
    //     return this.personalAreaUserPdf ? this.userData.last_name + '_' + this.userData.first_name : this.commonUserData.last_name + '_' + this.commonUserData.first_name
    // }
  },
  methods: {
    ...mapActions('userInterface', ['onUserInterfacePage']),
    ...mapActions('user', ['getUser']),
    exportToPDF() {
      const fileName = this.userData.first_name + '_' + this.userData.last_name + '.pdf'
    },
    onProgress(progress) {
      this.progress = progress
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    onImgReady(data) {
      this.imgReady = data
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    async generatePdf() {
      this.$store.commit('setLoadingAnimationFullPage', true)
      // this.setLoadingAnimationFullPage(true)
      // let target = this.$refs.target
      let target = document.getElementById('target')
      let header = document.getElementById('pdf_header')
      let footer = document.getElementById('pdf_footer')
      let headerHeight = header.offsetHeight * 0.75
      let headerWidth = header.offsetWidth * 0.75
      let footerHeight = footer.offsetHeight * 0.75
      let footerWidth = footer.offsetWidth * 0.75
      // число умноженное на 0,75 это перевод px в pt
      console.log('target', target)
      console.log('header', header)
      console.log('footer', footer)
      let filename = this.personalAreaUserPdf
        ? this.userData.first_name + ' ' + this.userData.last_name
        : this.commonUserData.first_name +
          ' ' +
          this.commonUserData.last_name +
          ' ' +
          $formatDate(new Date().toJSON().slice(0, 10)) +
          '.pdf'
      await html2pdf()
        .from(target)
        .set({
          margin: [0, -2.6, 0, 0],
          // margin: [headerHeight + 35 * 0.75, -2.6, footerHeight + 25 * 0.75, 0],
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            dpi: 96,
            scrollX: 0,
            scrollY: 0,
            backgroundColor: '#FFF',
            scale: 3,
            useCORS: true,
          },
          jsPDF: {
            unit: 'pt',
            format: [target.offsetWidth * 0.75, target.offsetHeight * 0.75],
            orientation: 'p',
          },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        })
        .toPdf()
        .get('pdf')
        .then(async function (pdf) {
          // var totalPages = pdf.internal.getNumberOfPages()
          // let footerCanvas = await html2canvas(footer, {
          //     scale: 2,
          //     useCORS: true,
          // })
          // let footerImg = footerCanvas.toDataURL('image/png')
          // let headerCanvas = await html2canvas(header, {
          //     scale: 2,
          //     useCORS: true,
          // })
          // let headerImg = headerCanvas.toDataURL('image/png')
          // for (let i = 1; i <= totalPages; i++) {
          //     pdf.setPage(i)
          //     pdf.setFontSize(12)
          //     pdf.setTextColor('#333333')
          //     pdf.text(
          //         i + '/' + totalPages,
          //         pdf.internal.pageSize.getWidth() - 22.5,
          //         headerHeight + 17.5,
          //         { align: 'right' },
          //     )
          //     pdf.addImage(headerImg, 0.7, 0, headerWidth, headerHeight)
          //     pdf.addImage(
          //         footerImg,
          //         0.7,
          //         pdf.internal.pageSize.getHeight() - footerHeight,
          //         footerWidth,
          //         footerHeight,
          //     )
          // }
          pdf.save(filename)
        })
        .catch((err) => console.log(err))
      this.$store.commit('setLoadingAnimationFullPage', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.bg {
  padding: 40px 0 60px;
  position: relative;
  display: grid;
  grid-template-columns: max-content auto;

  .control {
    width: max-content;
    height: max-content;
    background: #ffffff;
    border: 1px solid #333333;
    border-radius: 10px;
    padding: 30px;
    display: grid;
    justify-content: center;
    justify-items: center;
    grid-row-gap: 20px;
    transition: 0.5s;
    &_btn {
      padding: 11px 20px;
      width: max-content;
      background: #277faf;
      color: #ffffff;
      border-radius: 28px;
      transition: 0.3s;
      &:hover {
        background: #16558f;
      }
    }
    &.disable {
      opacity: 0;
    }
  }
  .borderBox {
    border: 1px solid #b4b4b4;
    width: max-content;
    margin: auto;
    height: max-content;
    .page {
      // max-width: 595pt;
      max-width: 950px;
      width: 100%;
      background: #ffffff;
      // height: 1350px;
      // display: grid;
      // display: grid;
      // flex-direction: column;
      // grid-template-rows: 60px auto 38px;
    }
  }
}
</style>
